import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export const FaqPage = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const faqs = [{
    question: 'Hoe lang duurt het wrappen van een auto?',
    answer: 'Het wrappen van een auto duurt gemiddeld 3-5 werkdagen, afhankelijk van de grootte van het voertuig en de complexiteit van het ontwerp. Bij BKCustoms streven we naar perfectie, dus we nemen de tijd die nodig is om een hoogwaardige afwerking te garanderen.'
  }, {
    question: 'Is een carwrap schadelijk voor de originele lak?',
    answer: 'Nee, een professioneel aangebrachte carwrap beschermt juist de originele lak. De wrap fungeert als een beschermende laag tegen steenslag, UV-straling en lichte krassen. Bij het verwijderen blijft de originele lak in perfecte staat, vaak zelfs beter dan zonder wrap.'
  }, {
    question: 'Hoe lang gaat een carwrap mee?',
    answer: 'Een kwaliteits carwrap gaat gemiddeld 5-7 jaar mee, afhankelijk van de gebruikte materialen, blootstelling aan weersinvloeden en hoe goed de wrap wordt onderhouden. Bij BKCustoms gebruiken we alleen premium materialen voor een optimale levensduur.'
  }, {
    question: 'Kan ik mijn auto wassen na het wrappen?',
    answer: 'Ja, dat kan. We adviseren om de eerste week na installatie niet te wassen. Daarna kunt u uw auto gewoon wassen, bij voorkeur handmatig met milde zeep of bij een touchless carwash. Vermijd hogedrukreinigers en harde borstels die de wrap kunnen beschadigen.'
  }, {
    question: 'Hoe donker mag ik mijn autoramen tinten in Nederland?',
    answer: 'Volgens de Nederlandse wetgeving mogen de voorste zijruiten minimaal 70% lichtdoorlatend zijn. Voor de achterste zijruiten en achterruit gelden geen specifieke beperkingen. Bij BKCustoms adviseren we over de wettelijke mogelijkheden en bieden we verschillende tinten aan die zowel aan de wetgeving voldoen als aan uw wensen.'
  }, {
    question: 'Kan ik na het tinten van de ramen direct de auto gebruiken?',
    answer: 'Na het tinten van de ramen adviseren wij om de ramen 3-5 dagen gesloten te houden, zodat de folie goed kan uitharden. Tijdens deze periode kan er een lichte waas of kleine luchtbelletjes zichtbaar zijn, maar deze verdwijnen vanzelf tijdens het uithardingsproces.'
  }, {
    question: 'Bieden jullie garantie op de diensten?',
    answer: 'Ja, bij BKCustoms bieden we garantie op al onze diensten. Voor carwraps geldt een garantie van 3 jaar op materiaal en installatie. Voor raamtinting bieden we 5 jaar garantie tegen verkleuring en loslaten. Voor specifieke garantievoorwaarden kunt u contact met ons opnemen.'
  }, {
    question: 'Kan ik mijn auto verzekeren na een wrap of modificatie?',
    answer: 'Ja, dat kan. Een carwrap of andere cosmetische modificaties hebben meestal geen invloed op uw verzekering. We adviseren wel om uw verzekeraar te informeren over de aangebrachte modificaties. Voor substantiële modificaties kunnen wij een certificaat verstrekken dat u aan uw verzekeraar kunt overhandigen.'
  }];
  return <main data-id="element-1505">
      {/* Header Banner */}
      <div className="relative bg-[#0a0a0a] py-28" data-id="element-1506">
        <div className="absolute inset-0 overflow-hidden" data-id="element-1507">
          <div className="absolute inset-0 bg-black/80 z-10" data-id="element-1508"></div>
          <img src="https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2083&q=80" alt="Auto customization FAQ" className="w-full h-full object-cover object-center" data-id="element-1509" />
        </div>
        <div className="relative z-20 max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-1510">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-1511">
            Veelgestelde <span className="text-[#D6281F]" data-id="element-1512">Vragen</span>
          </h1>
          <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-1513">
            Antwoorden op de meest gestelde vragen over onze diensten en
            werkwijze.
          </p>
        </div>
      </div>
      {/* FAQ Section */}
      <section className="bg-[#0a0a0a] py-20" data-id="element-1514">
        <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-1515">
          <div className="space-y-6" data-id="element-1516">
            {faqs.map((faq, index) => <div key={index} className="bg-[#0f0f0f] border border-[#222] rounded-lg overflow-hidden" data-id="element-1517">
                <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => toggleFaq(index)} data-id="element-1518">
                  <span className="font-semibold text-white text-lg" data-id="element-1519">
                    {faq.question}
                  </span>
                  {openIndex === index ? <ChevronUpIcon className="text-[#D6281F] w-5 h-5 flex-shrink-0" data-id="element-1520" /> : <ChevronDownIcon className="text-white w-5 h-5 flex-shrink-0" data-id="element-1521" />}
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-1522">
                  <p className="text-white/80" data-id="element-1523">{faq.answer}</p>
                </div>
              </div>)}
          </div>
          <div className="mt-16 text-center" data-id="element-1524">
            <p className="text-white/80 mb-6" data-id="element-1525">
              Heeft u een vraag die hier niet wordt beantwoord?
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-1526">
              <a href="/contact" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide" data-id="element-1527">
                Neem contact op
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>;
};